// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Button } from '@mantine/core';
import { IconVideo } from '@tabler/icons-react';
import type { JSX } from 'react';

interface AppointmentJoinButtonProps {
  joinUrl?: string;
  canConduct?: boolean;
  onClick?: () => void;
}

export function AppointmentJoinButton({
  joinUrl,
  canConduct = true,
  onClick,
}: AppointmentJoinButtonProps): JSX.Element {
  const disabled = !joinUrl || !canConduct;
  return (
    <Button size="xs" leftSection={<IconVideo size={14} />} onClick={onClick} disabled={disabled}>
      Join
    </Button>
  );
}
